import * as THREE from "three";
import { Jaw } from "./viewer/interfaces.ts";

export function isLower(object) {
  return object.userData["jaw"] === Jaw.Lower;
}

export function isUpper(object) {
  return object.userData["jaw"] === Jaw.Upper;
}

export function isPontics(object) {
  return object.userData["isPontics"];
}

export function isStep(object, stepNumber) {
  return object.userData["step"] === stepNumber;
}

export function isGum(object) {
  return object.name.includes("gum");
}

export function isTooth(object) {
  return object.name.includes("_t");
}

export function clone(object) {
  if (isGum(object)) {
    return cloneGum(object);
  } else if (isTooth(object)) {
    return cloneTooth(object);
  } else {
    return object.clone();
  }
}

export function getToothKey(tooth) {
  return "t" + getToothNumber(tooth);
}

export function getToothNumber(tooth) {
  let number = tooth.userData["number"];

  if (!number) {
    number = getToothNumberByName(tooth.name);
  }
  return number;
}

export function getToothNumberByName(name) {
  return name.split("_")[2].substring(1, 4);
}

/**
 * similar to three js clone but in addition of cloning the custom variables of the gum and desending teeth
 * @param {Mesh} gum
 * @returns
 */
export function cloneGum(gum) {
  const clonedGum = gum.clone(false);

  clonedGum.userData = gum.userData;

  gum.children.forEach(tooth => {
    clonedGum.attach(cloneTooth(tooth));
  });

  return clonedGum;
}
export function cloneTooth(tooth) {
  const clonedTooth = tooth.clone();

  clonedTooth.userData = tooth.userData;

  return clonedTooth;
}
export function isToothLeftSide(object) {}

export function isToothRightSide(object) {}

export function drawSphere(position, radius, parent, color) {
  const sphereGeometry = new THREE.SphereGeometry(radius, 16, 16);

  // 2. Create the material (the appearance)
  const sphereMaterial = new THREE.MeshBasicMaterial({
    color: color,
  });

  // 3. Create the mesh (the final object)
  const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);

  sphere.position.copy(position);
  parent.attach(sphere);
  return sphere;
}

export function drawPlane(position, parent, color) {
  const geometry = new THREE.PlaneGeometry(1000, 1000);
  const material = new THREE.MeshBasicMaterial({
    color: color,
    side: THREE.DoubleSide,
    visible: false,
  });
  const plane = new THREE.Mesh(geometry, material);

  plane.position.copy(position);
  parent.attach(plane);
  return plane;
}

export function getRaycastOnPlane(startPoint, direction, plane) {
  const raycaster = new THREE.Raycaster();
  raycaster.set(startPoint, direction.clone().normalize());

  const intersect = raycaster.intersectObject(plane, false);

  if (!intersect.length) {
    console.error("The ray does not intersect the plane.");
    return 0;
  }

  const targetPoint = intersect[0].point;

  return targetPoint;
}

export function removeAllChildren(parent) {
  for (let childrenIndex = 0; childrenIndex < parent.children.length; ) {
    parent.children[childrenIndex].removeFromParent();
  }
}
